/**
 * Single source of truth for the firm's contact and location details.
 * Every footer, contact surface and JSON-LD block reads from here so an
 * address change is one edit, not fifteen.
 */

export const businessInfo = {
  name: "Infinity Financial Solutions",
  legalName: "Infinity Financial Solutions Limited",
  companyNumber: "14433335",
  url: "https://infinity-fs.co.uk",
  logo: "https://infinity-fs.co.uk/IFS_Logo_v2.webp",
  ogImage: "https://infinity-fs.co.uk/og-image.jpg",
  email: "info@infinity-fs.co.uk",
  telephone: "01722 466213",
  telephoneE164: "+441722466213",
  telephoneHref: "tel:01722466213",
  openingHours: "Mon–Fri: 9am – 5pm",
  address: {
    streetAddress: "7 Oakridge Office Park",
    addressLine2: "Southampton Road, Whaddon",
    addressLocality: "Salisbury",
    addressRegion: "Wiltshire",
    postalCode: "SP5 3HT",
    addressCountry: "GB",
  },
  geo: { lat: 51.0218, lng: -1.7385 },
} as const;

/** One-line address for footers, cards and inline copy. */
export const addressOneLine =
  "7 Oakridge Office Park, Southampton Road, Whaddon, Salisbury, SP5 3HT";

/** Multi-line address parts, in display order. */
export const addressLines = [
  "Infinity Financial Solutions Limited",
  "7 Oakridge Office Park",
  "Southampton Road, Whaddon",
  "Salisbury",
  "SP5 3HT",
];

/** schema.org PostalAddress for JSON-LD blocks. */
export const postalAddressSchema = {
  "@type": "PostalAddress",
  streetAddress: "7 Oakridge Office Park, Southampton Road",
  addressLocality: "Whaddon, Salisbury",
  addressRegion: "Wiltshire",
  postalCode: "SP5 3HT",
  addressCountry: "GB",
} as const;

export const mapsUrl =
  "https://www.google.com/maps/search/?api=1&query=Infinity+Financial+Solutions+7+Oakridge+Office+Park+Southampton+Road+Whaddon+Salisbury+SP5+3HT";

/** Places we hold a genuine presence, used for areaServed and copy. */
export const primaryAreas = [
  "Salisbury",
  "Wiltshire",
  "Fordingbridge",
  "New Forest",
  "Wimborne",
  "Dorset",
];
